import { mapCollection } from '../../utils/collection.utils';
import { MasterTaskTool } from '../master-task-tool';
import { ToolBuilder } from './tool.builder';

export class MasterTaskToolBuilder {
  static fromJson(json) {
    return (json)
      ? new MasterTaskTool(
        json.hash,
        json.position,
        ToolBuilder.fromJson(json.tool).hash,
        ToolBuilder.fromJson(json.tool).name,
        ToolBuilder.buildToolHolderFromJson(json.toolHolder).hash,
        ToolBuilder.buildToolHolderFromJson(json.toolHolder).name,
        json.length,
        json.lastUpdate,
        json.status,
        json.masterTaskHash,
        json.created,
        json.sentToMeasure,
        json.measurementOK,
        json.measurementKO,
        json.markedToSend
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(MasterTaskToolBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/master-task-tool.builder.ts